import { features, whyItems, services, supplyItems, projects } from "../../mock";
import { uploadedPhotos } from "../../data/uploadedPhotos";

const hr = {
  meta: { title: "ORICO — Dizajn interijera i opremanje", description: "ORICO — projektiranje, dobava opreme i realizacija interijera hotela, ureda, restorana i rezidencija diljem Hrvatske." },
  nav: { home: "Početna", projects: "Projekti", services: "Usluge", contact: "Kontakt" },
  common: { language: "Jezik", menuOpen: "Otvori izbornik", menuClose: "Zatvori izbornik", search: "Pretraži", login: "Prijava", contactUs: "Kontaktirajte nas", requestQuote: "Zatražite ponudu", viewProjects: "Pogledajte projekte", interior: "Interijer", interiorDetail: "Detalj interijera", galleryImage: "{{category}} — interijer" },
  footer: {
    description: "Studio za dizajn, arhitekturu i izvedbu — projektiranje, uređenje interijera i gradnja, od koncepta do primopredaje, diljem Hrvatske.",
    navigation: "Navigacija", contact: "Kontakt", rights: "Sva prava pridržana.",
    words: ["Interijer", "Oprema", "Namještaj", "Rasvjeta", "Realizacija", "Dobava"],
  },
  home: {
    badge: "Dobava opreme · Interijer · Realizacija",
    intro: "Dobavljamo namještaj, inventar, opremu i građevinske materijale te realiziramo jedinstvene interijere hotela, ureda, restorana, wellnessa i rezidencija.",
    heroCaption: "Od koncepta\ndo izvedbe",
    statementLead: "ORICO je tvrtka za dobavu opreme i uređenje interijera",
    statementMuted: "— s velikim iskustvom u realizaciji jedinstvenih interijera za različite vrste objekata.",
    materialsLabel: "Materijali & teksture", materialsTitle: "Svaki prostor gradimo od pomno odabranih materijala",
    supplyTitle: "ŠTO\nDOBAVLJAMO", supplyIntro: "Od namještaja po mjeri do građevinskih materijala — sve na jednom mjestu, uz suradnju s vodećim proizvođačima.",
    partnersIntro: "Surađujemo sa svjetski poznatim proizvođačima",
    whyTitle: "ZAŠTO\nORICO?", whyBadge: "Zašto odabrati nas",
    detailsTitle: "DETALJI KOJI\nČINE RAZLIKU", detailsIntro: "Materijali, teksture i rasvjeta pomno odabrani za svaki prostor — isječci iz naših realizacija.",
    ctaLabel: "Započnite razgovor", ctaTitle: "Planirate\nsljedeći korak?",
  },
  features: features.map(({ title, subtitle, desc }) => ({ title, subtitle, desc })),
  why: whyItems.map(({ title, desc }) => ({ title, desc })),
  supply: supplyItems.map(({ title, desc }) => ({ title, desc })),
  services: services.map(({ title, desc }) => ({ title, desc })),
  projectsPage: {
    eyebrow: "Odabrani radovi", title: "PROJEKTI", lead: "Odabrane realizacije interijera",
    muted: "za hotele, wellness, rezidencije, urede, sportske centre, privatne klinike i restorane.", galleryTitle: "GALERIJA\nPROSTORA",
    galleryIntro: "Odabrani prizori interijera i eksterijera grupirani prema vrsti prostora — kao inspiracija za vaš sljedeći projekt.",
  },
  categories: { Sve: "Sve", Hoteli: "Hoteli", Wellness: "Wellness", Bazeni: "Bazeni", Rezidencije: "Rezidencije", Poslovno: "Poslovno", Sport: "Sportski centri", Klinike: "Privatne klinike", Restorani: "Restorani", Eksterijeri: "Eksterijeri" },
  projectNames: Object.fromEntries(projects.map((project) => [project.id, project.title])),
  servicesPage: {
    eyebrow: "Što nudimo", title: "USLUGE", lead: "Cjelovita podrška na svakom koraku —",
    muted: "od planiranja i dobave opreme do izrade namještaja i montaže.",
    ctaLabel: "Spremni za razgovor?", ctaTitle: "Ostvarimo vaš sljedeći projekt zajedno",
  },
  contact: {
    eyebrow: "Započnite razgovor", title: "KONTAKT", intro: "Recite nam što gradite, gdje se projekt nalazi i koje usluge trebate.",
    address: "Adresa", email: "E-mail", phone: "Telefon",
    fields: { name: "Ime i prezime", email: "E-mail", topic: "Predmet", message: "Poruka", website: "Web stranica" },
    placeholders: { name: "Ivan Horvat", email: "ivan@email.hr", topic: "Projektiranje / Opremanje / Ostalo", message: "Opišite vaš upit..." },
    submit: "Pošalji poruku", sending: "Slanje…", success: "Hvala! Vaša poruka je poslana. Javit ćemo vam se na navedeni e-mail.",
    errors: {
      validation: "Unesite ime i prezime, valjan e-mail i poruku od najmanje 5 znakova.",
      unavailable: "Slanje trenutačno nije dostupno. Vaš unos je sačuvan; pokušajte ponovno.",
      network: "Slanje nije potvrđeno. Provjerite internetsku vezu i pokušajte ponovno. Vaš unos je sačuvan.",
      unconfirmed: "Slanje nije potvrđeno. Pokušajte ponovno.",
      forbidden: "Zahtjev nije dopušten. Pokušajte ponovno poslati poruku.",
      sessionExpired: "Veza je istekla. Pokušajte ponovno poslati poruku.",
      csrf: "Sigurnosna provjera nije uspjela. Pokušajte ponovno poslati poruku.",
      rateLimit: "Previše pokušaja. Pričekajte nekoliko minuta pa pokušajte ponovno.",
      rejected: "Poruka nije prihvaćena. Pokušajte ponovno.",
      changed: "Sadržaj upita je promijenjen. Pokušajte ponovno.",
      processing: "Upit je već u obradi. Pričekajte pa pokušajte ponovno.",
      notFound: "Upit nije pronađen. Pokušajte ponovno.",
      blocked: "Poruka sadrži nedopušten sadržaj. Izmijenite tekst upita.",
      emailFailed: "Slanje e-maila nije potvrđeno. Unos je sačuvan; pokušajte ponovno ili nas kontaktirajte izravno.",
    },
  },
  photos: Object.fromEntries(Object.values(uploadedPhotos).map((photo) => [photo.id, photo.alt])),
};

export default hr;